import { createAppSelector } from 'store/hooks';

export const moreOptionModalSelector = createAppSelector(
  [
    (state) => state.modal.moreOption.activity,
    (state) => state.modal.moreOption.showYouTubeURLModal,
    (state) => state.modal.moreOption.showAllowedURLModal,
    (state) => state.modal.moreOption.showChoicesModal,
    (state) => state.modal.moreOption.showImageURLModal,
    (state) => state.modal.moreOption.showCheckListModal,
    (state) => state.modal.choice.showChoicesYouTubeURLModal
  ],
  (
    activity,
    showYouTubeURLModal,
    showAllowedURLModal,
    showChoicesModal,
    showImageURLModal,
    showCheckListModal,
    showChoicesYouTubeURLModal
  ) => {
    return {
      activity,
      showYouTubeURLModal,
      showAllowedURLModal,
      showChoicesModal,
      showImageURLModal,
      showCheckListModal,
      showChoicesYouTubeURLModal
    };
  }
);

export const modalContentSelector = createAppSelector(
  [
    (state) => state.setting.moreOptions.type,
    (state) => state.setting.platform,
    (state) => state.setting.flags,
    (state) => state.setting.mode,
    (state) => state.cache.youtube_urls_metadata.videos_metadata,
    (state) => state.modal.moreOption.activity,
    (state) => state.habitPack.packEditorTabMode
  ],
  (
    activityType,
    platform,
    flags,
    mode,
    videos_metadata,
    activity,
    packEditorTabMode
  ) => {
    return {
      activityType,
      platform,
      flags,
      mode,
      videos_metadata,
      activity,
      packEditorTabMode
    };
  }
);

export const modalContentHeaderHabitDurationSelector = createAppSelector(
  [
    (state) => state.modal.moreOption.activity,
    (state) => state.setting.currentSettings.evening_activities,
    (state) =>
      state.setting.currentSettings
        .cutoff_time_for_non_high_priority_activities,
    (state) => state.setting.currentSettings.shutdown_time,
    (state) => state.user.focus_modes
  ],
  (
    activity,
    evening_activities,
    cutoff_time,
    shutdown_time,
    user_focus_modes
  ) => {
    return {
      activity,
      evening_activities,
      cutoff_time,
      shutdown_time,
      user_focus_modes
    };
  }
);

export const modalContentHeaderSelector = createAppSelector(
  [(state) => state.modal.moreOption.activity],
  (activity) => {
    return { activity };
  }
);

export const desktopViewModalContentBodySelector = createAppSelector(
  [(state) => state.modal.moreOption.activity],
  (activity) => {
    return activity;
  }
);

export const moreOptionModalActionsSelector = createAppSelector(
  [
    (state) => state.modal.moreOption,
    (state) => state.setting.moreOptions,
    (state) => state.setting.currentSettings,
    (state) => state.setting.mode,
    (state) => state.setting.activityLibrary,
    (state) => state.course.tutorials,
    (state) => state.habitPack.packEditorTabMode,
    (state) => state.setting.currentSettings.custom_routines
  ],
  (
    moreOption,
    moreOptions,
    currentSettings,
    mode,
    activityLibrary,
    tutorials,
    packEditorTabMode,
    customRoutines
  ) => {
    return {
      moreOption,
      moreOptions,
      currentSettings,
      mode,
      activityLibrary,
      tutorials,
      packEditorTabMode,
      customRoutines
    };
  }
);

export const modalContentHeaderHabitNameSelector = createAppSelector(
  [
    (state) => state.modal.moreOption.activity,
    (state) => state.setting.mode,
    (state) => state.setting.customRoutine,
    (state) => state.routineSuggestions.rawRoutineSuggestions
  ],
  (activity, mode, customRoutine, rawRoutineSuggestions) => {
    return {
      activity,
      mode,
      customRoutine,
      rawRoutineSuggestions
    };
  }
);

export const moreOptionModalActivitySelector = createAppSelector(
  [(state) => state.modal.moreOption.activity],
  (activity) => {
    return activity;
  }
);

export const moreOptionModalImagesSectionSelector = createAppSelector(
  [
    (state) => state.modal.moreOption.activity,
    (state) => state.setting.moreOptions.type,
    (state) => state.setting.previousSettings,
    (state) => state.setting.previousActivityLibrary
  ],
  (activity, type, previousSettings, previousActivityLibrary) => {
    return {
      activity,
      type,
      previousSettings,
      previousActivityLibrary
    };
  }
);

export const moreOptionModalVideoURLsSelector = createAppSelector(
  [
    (state) => state.modal.moreOption.activity.video_urls ?? [],
    (state) => state.cache.isYouTubeURLMetadataUpdating,
    (state) => state.cache.youtube_urls_metadata.videos_metadata
  ],
  (video_urls, isYouTubeURLMetadataUpdating, videos_metadata) => {
    return { video_urls, isYouTubeURLMetadataUpdating, videos_metadata };
  }
);

export const moreOptionModalURLModalSelector = createAppSelector(
  [
    (state) => state.modal.moreOption.activity,
    (state) => state.modal.choice.choices,
    (state) => state.modal.choice.selectedPosition
  ],
  (activity, choices, selectedPosition) => {
    return { activity, choices, selectedPosition };
  }
);

export const moreOptionModalURLModalActionsSelector = createAppSelector(
  [
    (state) => state.modal.moreOption.activity,
    (state) => state.modal.choice.choices,
    (state) => state.modal.choice.selectedPosition
  ],
  (activity, choices, selectedPosition) => {
    return {
      activity,
      choices,
      selectedPosition
    };
  }
);

export const moreOptionModalURLModalInputURLSelector = createAppSelector(
  [
    (state) => state.modal.moreOption.activity,
    (state) => state.cache.isYouTubeURLMetadataFetching,
    (state) => state.cache.youtube_urls_metadata
  ],
  (activity, isYouTubeURLMetadataFetching, youtube_urls_metadata) => {
    return { activity, isYouTubeURLMetadataFetching, youtube_urls_metadata };
  }
);

export const moreOptionModalURLModalVideoMetaDataSelector = createAppSelector(
  [(state) => state.cache.youtube_urls_metadata],
  (youtube_urls_metadata) => {
    return youtube_urls_metadata;
  }
);

export const moreOptionModalImagesSelector = createAppSelector(
  [(state) => state.modal.moreOption.activity],
  (activity) => {
    return { activity };
  }
);

export const moreOptionModalTutorialSelector = createAppSelector(
  [
    (state) => state.modal.moreOption.activity.tutorial,
    (state) => state.course.tutorials,
    (state) => state.course.isFetchingTutorials
  ],
  (tutorialId, tutorials, isFetchingTutorials) => {
    return { tutorialId, tutorials, isFetchingTutorials };
  }
);

export const moreOptionModalPrioritySelector = createAppSelector(
  [(state) => state.filter.priority],
  (filterPriority) => {
    return { filterPriority };
  }
);

export const moreOptionModalTutorialOptionsSelector = createAppSelector(
  [
    (state) => state.course.tutorials,
    (state) => state.course.isFetchingTutorials,
    (state) => state.modal.moreOption.activity.tutorial
  ],
  (tutorials, isFetchingTutorials, tutorialId) => {
    return { tutorials, isFetchingTutorials, tutorialId };
  }
);

export const moreOptionChoiceItemActivityNameSelector = createAppSelector(
  [
    (state) => state.habitPack.packEditorTabMode,
    (state) => state.modal.choice.choices,
    (state) => state.modal.choice.showChoicesYouTubeURLModal,
    (state) => state.setting.mode
  ],
  (packEditorTabMode, choices, showChoicesYouTubeURLModal, generatorMode) => {
    return {
      packEditorTabMode,
      choices,
      showChoicesYouTubeURLModal,
      generatorMode
    };
  }
);

export const moreOptionChoiceItemYouTubeVideosSelector = createAppSelector(
  [
    (state) => state.modal.choice.choices,
    (state) => state.cache.youtube_urls_metadata.videos_metadata,
    (state) => state.cache.isYouTubeURLMetadataUpdating
  ],
  (choices, videos_metadata, isYouTubeURLMetadataUpdating) => {
    return { choices, videos_metadata, isYouTubeURLMetadataUpdating };
  }
);

export const moreOptionChoiceItemChoiceCompletionUsingLevelSelector =
  createAppSelector([(state) => state.modal.choice.choices], (choices) => {
    return { choices };
  });

export const moreOptionChoiceItemChoiceCompletionRequirementsSelector =
  createAppSelector([(state) => state.modal.choice.choices], (choices) => {
    return { choices };
  });

export const moreOptionChoiceItemSelector = createAppSelector(
  [
    (state) => state.modal.choice.choices,
    (state) => state.cache.youtube_urls_metadata.videos_metadata
  ],
  (choices, videos_metadata) => {
    return { choices, videos_metadata };
  }
);

export const moreOptionChoiceItemChoiceCompletionUsingTimerSelector =
  createAppSelector([(state) => state.modal.choice.choices], (choices) => {
    return { choices };
  });

export const activityLibraryMoreOptionsMoveActivitySelector = createAppSelector(
  [
    (state) => state.setting.currentSettings.custom_routines,
    (state) => state.setting.moreOptions,
    (state) => state.modal.moreOption.activity
  ],
  (customRoutines, moreOptions, activity) => {
    return { customRoutines, moreOptions, activity };
  }
);

export const moreOptionActivityChoicesTabSelector = createAppSelector(
  [
    (state) => state.modal.moreOption.activity,
    (state) => state.setting.moreOptions.type
  ],
  (activity, activityType) => {
    return { activity, activityType };
  }
);

export const moreOptionChoiceItemRandomChoicesSelector = createAppSelector(
  [
    (state) => state.modal.moreOption.activity,
    (state) => state.setting.moreOptions.type
  ],
  (activity, activityType) => {
    return { activity, activityType };
  }
);
